import { Injectable, inject } from '@angular/core';
import { UrlTree, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SiteState } from 'src/app/shared/models';

import { selectActiveBatch } from '../store/selectors/batch.selectors';

@Injectable({
  providedIn: 'root',
})
export class BatchConfigurationEditGuard {
  private readonly router = inject(Router);
  private readonly store = inject<Store<SiteState>>(Store);

  canActivate(activatedRouteSnapShot: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.store.pipe(
      select(selectActiveBatch, Number(activatedRouteSnapShot.params?.id)),
      map((batch) => (!!batch ? true : this.router.parseUrl(`/registration/batches`))),
    );
  }
}
